import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import Property from '../../../../../components/Table/DownPropertyTable';
import VehicleTable from '../../../../../components/Table/DownVehicleTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import {Itabs} from '../../../../../interface/Tab';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const DownStreamAM: React.FC<{
  selectedYear: string;
  isConfigurator?: boolean;
  isAssetManager?: boolean;
  planPropertyKey: accessModule;
  planVehicleKey: accessModule;
}> = ({
  selectedYear,
  isConfigurator,
  isAssetManager,
  planPropertyKey,
  planVehicleKey
}) => {
  const downStreamTab: Itabs[] = [
    {
      id: `property_${planPropertyKey}`,
      name: <TranslatedText translationKey="Property" />,
      component: shouldBlockModuleAccess(planPropertyKey) ? (
        <BlockAccessPage />
      ) : (
        <Property
          selectedYear={selectedYear}
          isConfigurator={isConfigurator}
          isAssetManager={isAssetManager}
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerDownstreamProperty
      )
    },
    {
      id: `vehicle_${planVehicleKey}`,
      name: <TranslatedText translationKey="Vehicle" />,
      component: shouldBlockModuleAccess(planVehicleKey) ? (
        <BlockAccessPage />
      ) : (
        <VehicleTable
          selectedYear={selectedYear}
          isConfigurator={isConfigurator}
          isAssetManager={isAssetManager}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerDownstreamVehicle)
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={downStreamTab} />;
};

export default DownStreamAM;
